<template>
  <div class="text-center login_container">
    <form class="form-signin">
      <h1 class="h3 mb-3 font-weight-normal">Please log in</h1>
      <b-alert show variant="danger" v-if="error">{{ error }}</b-alert>
      <label for="inputUsername" class="sr-only">Username</label>
      <input type="text" id="inputUsername" class="form-control" placeholder="Username" v-model="username" required
        autofocus />
      <label for="inputPassword" class="sr-only">Password</label>
      <input type="password" id="inputPassword" class="form-control" placeholder="Password" v-model="password" required />
      <button class="btn btn-lg btn-primary btn-block" type="submit" @click="handleSubmit">
        Log in
      </button>
    </form>
  </div>
</template>

<script>
export default {
  data() {
    return {
      username: "",
      password: "",
      error: ""
    };
  },
  methods: {
    handleSubmit(e) {
      this.error = "";
      e.preventDefault();
      var self = this;
      if (this.password.length > 0) {
        this.$http
          .post(this.APIURL + "login", {
            username: this.username,
            password: this.password
          })
          .then(response => {
            console.log(JSON.stringify(response.data.user));
            localStorage.setItem("user", JSON.stringify(response.data.user));
            localStorage.setItem("jwt", response.data.token);

            if (localStorage.getItem("jwt") != null) {
              location.reload();
            }
          })
          .catch(function (error) {
            self.error = error.response.data.error;
          });
      }
    }
  }
};
</script>
